import React, { FC, useState } from 'react'
import {useTranslation} from "../../../../providers/LocalizationProvider";

interface ContactFormProps {
	onSubmit: (data: { name: string; phone: string }) => void
}

const ContactForm: FC<ContactFormProps> = ({ onSubmit }) => {
	const {t, tHtml} = useTranslation()
	const [formData, setFormData] = useState({
		name: String(localStorage.getItem('name') || ''),
		phone: String(localStorage.getItem('phone') || '')
	})
	const [agreedToPrivacy, setAgreedToPrivacy] = useState(Boolean(localStorage.getItem('agreedToPrivacy') || false))

	const isValid =
		formData.name.trim() !== '' &&
		formData.phone.trim() !== '' &&
		agreedToPrivacy

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target
		localStorage.setItem(name, value)
		setFormData(prev => ({
			...prev,
			[name]: value
		}))
	}

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault()
		if (isValid) {
			onSubmit(formData)
		}
	}

	return (
		<div
			className='bg-grey-100 min-h-screen flex items-center py-8 md:py-0 relative bg-center bg-cover'
			style={{ backgroundImage: `url(/form-bg.png)` }}
		>
			<div className='max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8'>
				<div className='grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center relative z-10'>
					<div className='rounded-3xl p-8 sm:p-10'>
						<h2 className='text-4xl font-bold text-grey-400 mb-3'>
							{t("contact.title")}
						</h2>

						<p className='text-grey-400 font-medium mb-8'>
							{t("contact.subtitle")}
						</p>

						<form onSubmit={handleSubmit} className='space-y-4'>
							<input
								type='text'
								name='name'
								placeholder={t("contact.name_placeholder")}
								value={formData.name}
								onChange={handleChange}
								className='w-full px-6 py-4 bg-grey-100 border border-grey-200 rounded-full text-grey-400 placeholder-grey-300 focus:outline-none focus:border-blue focus:ring-2 focus:ring-blue/10 transition-all'
							/>

							<input
								type='tel'
								name='phone'
								placeholder={t("contact.phone_placeholder")}
								value={formData.phone}
								onChange={handleChange}
								className='w-full px-6 py-4 bg-grey-100 border border-grey-200 rounded-full text-grey-400 placeholder-grey-300 focus:outline-none focus:border-blue focus:ring-2 focus:ring-blue/10 transition-all'
							/>

							<div className='space-y-3 py-4'>
								<label className='flex items-start gap-3 cursor-pointer group'>
									<input
										type='checkbox'
										checked={agreedToPrivacy}
										onChange={e => {
											localStorage.setItem('agreedToPrivacy', String(e.target.checked))
											setAgreedToPrivacy(e.target.checked)
										}}
										className='w-5 h-5 rounded border-2 border-grey-300 bg-white cursor-pointer accent-blue'
									/>
									<span className='text-sm text-white font-medium transition-colors'>
										{tHtml("contact.privacy_text")}
									</span>
								</label>
							</div>

							<button
								type='submit'
								disabled={!isValid}
								className='py-3 px-8 md:w-auto w-full bg-black hover:bg-black/80 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold rounded-full transition-all mt-6'
							>
								{t("contact.submit")}
							</button>
						</form>
					</div>

					<div className='hidden lg:flex items-center justify-center'>
						<div className='relative w-full max-w-full'>
							<img
								src='/form.png'
								alt={t("image_alt.podborka_nedvijimosti")}
								className='w-full h-auto'
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ContactForm
